import React from "react";
import withProviders from "../../hooks/withProviders";
import { FilterProvider, AgedDebtorManagementDefaultFilters } from "../../hooks/FilterContext";
import HeadOfficeAgedDebtorsManagement from "../../features/headofficeageddebtorsmanagement";

const AgedDebtorsManagementPage = () => <HeadOfficeAgedDebtorsManagement />

export default withProviders([FilterProvider, { defaultFilters: AgedDebtorManagementDefaultFilters, filterStore: 'admin.management.ageddebtors' }])(AgedDebtorsManagementPage);